import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost } from '../../../../../utils/AxiosUtil';
import ErrorAwareNumberField from '../../../../common/inputfields/ErrorAwareNumberField';
import MyCreatableAutocomplete from '../../../../common/inputfields/MyAutocomplete';
import NewAgainField from '../../../../common/inputfields/NewAgainField';

class NewAvailableVacation extends Component {

    state = {
        newAgain: false,
        selectedEmployee: {},
        year: new Date().getFullYear(),
        days: '',
        notUsedDays: '',
        addedDays: '',
        partnerDisabled: false,
        errors: new Map(),
    }

    componentDidMount() {
        console.log(this.props);
        if (this.props.row) {
            // console.log(this.props.row);
            let employee;
            let year2 = new Date().getFullYear();
            if ("EMPLOYEE" === this.props.row.rowType && this.props.row.employee.name) {
                employee = { label: this.props.row.employee.name, value: this.props.row.employee.privateId }
            } else if ("AVAILABLE_VACATION" === this.props.row.rowType && !this.props.row.privateId) {
                employee = { label: this.props.row.employeeName, value: this.props.row.employeeId }
                year2 = this.props.row.year;
            }
            this.setState({ partnerDisabled: true, selectedEmployee: employee, year: year2 })
        }
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            selectedEmployee: {},
            year: new Date().getFullYear(),
            days: '',
            notUsedDays: '',
            addedDays: '',
            partnerDisabled: false,
            errors: new Map(),
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/availablevacation';
        const requestObject = {
            "employeeId": this.state.selectedEmployee.value,
            "year": this.state.year,
            "days": this.state.days,
            "notUsedDays": this.state.notUsedDays,
            "addedDays": this.state.addedDays,
        };
        console.log(requestObject);
        handlePost(path, requestObject, this);
    };

    promiseEmployeeOptions = async () => {
        const params = {
            type: 'FULL_TIME'
        };
        const response = await axios.get('/api/employees', { params })
        const renamedCustomers = [];
        response.data.map((resp) =>
            renamedCustomers.push({
                label: resp.employee.name,
                value: resp.employee.privateId,
            }));
        return renamedCustomers;
    };

    handleEmployeeSelected = (e, v) => {
        this.setState({ selectedEmployee: v })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedEmployee || ''}
                            defaultvale={this.state.selectedEmployee}
                            getOptions={this.promiseEmployeeOptions}
                            onChange={this.handleEmployeeSelected}
                            disabled={this.state.partnerDisabled}
                            label={'Munkavállaló'}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            required
                            name="year"
                            label="Év"
                            errors={this.state.errors}
                            value={this.state.year}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            required
                            name="days"
                            label="Napok száma"
                            errors={this.state.errors}
                            value={this.state.days}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            name="addedDays"
                            label="Hozzáadott napok száma"
                            errors={this.state.errors}
                            value={this.state.addedDays}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            name="notUsedDays"
                            label="Nem használt napok száma"
                            errors={this.state.errors}
                            value={this.state.notUsedDays}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    {this.state.partnerDisabled ? <></> :
                        <NewAgainField
                            checked={this.state.newAgain}
                            onChange={e => this.setState({ newAgain: e.target.checked })} />
                    }
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewAvailableVacation);
